import {
  Avatar,
  Backdrop,
  Box,
  Chip,
  CircularProgress,
  Container,
  Dialog,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { DateTime } from "luxon";
import { useCallback, useEffect, useState } from "react";

import {
  axios,
  getBackgroundColor,
  getHoverBackgroundColor,
  Transition,
} from "../../commons";

import Page from "../elements/Page";
import UserForm from "./UserForm";

const UserList = () => {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(false);
  const [isShownBackdrop, toggleShownBackdrop] = useState(false);

  const load = useCallback(async () => {
    toggleShownBackdrop(true);
    try {
      const { data } = await axios.get(`/admin/users`);

      // console.log({ data });

      setItems(data);
    } catch (err) {
      console.error(err);
    }
    toggleShownBackdrop(false);
  }, []);

  const loadItem = useCallback(async (id) => {
    toggleShownBackdrop(true);
    try {
      const { data } = await axios.get(`/admin/users/${id}`);

      console.log({ data });

      setEditing({ ...data, id });
    } catch (err) {
      console.error(err);
    }
    toggleShownBackdrop(false);
  }, []);

  const handleClose = useCallback(
    (isSaved) => {
      if (isSaved === true) {
        load();
      }

      setEditing(false);
    },
    [load]
  );

  useEffect(load, [load]);

  return (
    <>
      <Page
        title="Users"
        //  display="flex" height="100%"
      >
        <Container
          maxWidth="xl"
          // sx={{ display: "flex", flexDirection: "column" }}
        >
          <Box sx={{ pb: 5 }} display="flex">
            <Typography variant="h4">Users</Typography>
          </Box>

          <Box
            flexGrow={1}
            sx={{
              "& .deleted": {
                bgcolor: (theme) =>
                  getBackgroundColor(
                    theme.palette.error.main,
                    theme.palette.mode
                  ),
                "&:hover": {
                  bgcolor: (theme) =>
                    getHoverBackgroundColor(
                      theme.palette.error.main,
                      theme.palette.mode
                    ),
                },
              },
            }}
          >
            <DataGrid
              autoHeight
              rows={items}
              columns={columns}
              getRowClassName={(params) =>
                `${params.row.deletedAt ? "deleted" : ""}`
              }
              onRowClick={({ id }) => {
                loadItem(id);
              }}
            />
          </Box>
        </Container>
      </Page>

      <Dialog
        fullScreen
        open={!!editing}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        {!!editing && (
          <UserForm
            initialValues={editing}
            onStartProcess={() => {
              toggleShownBackdrop(true);
            }}
            onClose={handleClose}
          />
        )}
      </Dialog>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
        open={isShownBackdrop}
        onClick={() => {
          // toggleShownBackdrop(false);
        }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default UserList;

const columns = [
  {
    field: "displayName",
    headerName: "표시 이름",
    minWidth: 220,
    renderCell: (params) => {
      return (
        <Chip
          avatar={
            <Avatar alt={params.row.displayName} src={params.row.photoURL} />
          }
          label={params.row.displayName}
          variant="outlined"
        />
      );
    },
  },
  {
    field: "name",
    headerName: "가입 실명",
    width: 100,
    valueFormatter: ({ value }) => value || "(미가입)",
  },
  { field: "email", headerName: "메일 주소", flex: 1 },
  {
    field: "createdAt",
    headerName: "Joined at",
    width: 180,
    valueFormatter: ({ value }) =>
      DateTime.fromISO(value).toLocaleString(DateTime.DATETIME_SHORT),
  },
  {
    field: "approved",
    headerName: "가입 승인",
    renderCell: (params) => {
      const { approved } = params.row;
      const isApproved = approved && approved.isApproved;

      return isApproved ? (
        <Chip label="승인됨" variant="outlined" color="success" />
      ) : (
        "미승인"
      );
    },
  },
];
